import { BaseServiceDefinition } from './BaseService';
import { MemberApplication } from '@/models/memberApplication';
import { Config } from '@/utils/Config';

class ApplicationServiceDefinition extends BaseServiceDefinition {

    constructor() {
        super();
    }
    
    sendApplication(data: MemberApplication): Promise<any> {
        return this.post('/api/v1/application', {
            application: data,
            redirectBaseUrl: Config.ExternalSettings.PageUrl
        });
    }
}

export const ApplicationService: ApplicationServiceDefinition = new ApplicationServiceDefinition();